export function formatRelativeTime(timestamp) {
  try {
    const now = new Date();
    const then = new Date(timestamp);
    if (isNaN(then.getTime())) return "Unknown";
    const diffMs = now - then;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return then.toLocaleDateString();
  } catch {
    return "Unknown";
  }
}
